import axios from 'axios'
window.axios = axios
Vue.prototype.$axios = axios

import { getPreviewUrl, getUrlParam } from './util';
import { langConfig } from './settings'

const isCartRequest = url => /^\/api\/store\/cart(\/([0-9a-f]{32})?)?$/.test(url.replace(/\?.+$/, ''));

let lastCartData;

/**
 * fix: #WSHOP-12585
 * 如果先发起 GET 请求，
 * 再发起任何修改请求，
 * 然后修改请求的返回先回来，
 * 则 GET 请求的返回值会被替换为修改请求的返回值。
 */

// 请求拦截处理器
const requestHandler = config => {
  const locale = langConfig[window.i18n.locale] || 'en-US';
  config.headers['X-LANG'] = locale
  // 如果是处于预览模式
  if (window.onPreviewLinkObserver) {
    const previewCode = getUrlParam('preview')
    const { url } = config
    let newUrl = url
    if (previewCode) {
      newUrl = getPreviewUrl(url, previewCode)
    }

    config.url = newUrl
  }

  // fix: #WSHOP-12585
  if (isCartRequest(config.url)) {
    if (config.method.toUpperCase() === 'GET') {
      // 先发起 GET 请求
      if (lastCartData === undefined) {
        // null 代表先发起了 GET 请求
        lastCartData = null
      }
    }
  }

  return config
}

// 请求拦截
axios.interceptors.request.use(requestHandler)

// 响应拦截处理器
const responseHandler = res => {
  if ( res?.data?.notices?.length) {
    res.data.notices.forEach((item, index) => {
      ELEMENT.Message({
        showClose: true,
        message: item,
        type: 'error',
        duration: 0,
        offset: 60 * (index + 1),
      })
    })
  }

  // fix: #WSHOP-12585
  if (isCartRequest(res.config.url)) {
    if (res.config.method.toUpperCase() === 'GET') {
      // 先发起的 GET 请求后回来，则使用后发起的变更请求的返回值
      if (lastCartData) {
        res.data = lastCartData;
      }
      // 重置掉，让后续的请求的逻辑从头开始
      lastCartData = undefined;
    } else {
      // null 标识，说明前面有 GET 请求
      if (lastCartData === null) {
        lastCartData = res.data;
      }
    }
  }

  return res
}
// 响应异常拦截处理器
const responseErrHandler = error => {
  if(error?.response?.status ===504){
     error.response.data ={message:'Connection timed out, please try again'}
  }
  return Promise.reject(error);
}

// 响应拦截
axios.interceptors.response.use(responseHandler, responseErrHandler)

// ！！！先放在这里，因为这个是所有主题都会引用的文件！！！
// 解决移动端a标签因为hover点击两次的问题
document.body.addEventListener('touchstart', function () { });
